import { Link } from 'react-router-dom';

interface CasesNavbarProps {
  scrolled: boolean;
}

export default function CasesNavbar({ scrolled }: CasesNavbarProps) {
  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/607c853629dc4b228801d270367dd43a/15c46b4804cbc70ab5f2207b2f29e22b.png"
              alt="NeuroAgents Global AI"
              className="h-10 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-white/80 hover:text-white uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              HOME
            </Link>
            <Link
              to="/casos-de-sucesso"
              className="text-[#10B981] uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              CASOS DE SUCESSO
            </Link>
            <a
              href="https://wa.me/5541992584018?text=Olá! Quero saber mais sobre a NeuroAgents"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#10B981] text-black px-6 py-2.5 rounded-full text-sm font-bold hover:bg-[#0EA472] transition-all cursor-pointer whitespace-nowrap"
            >
              FALAR COM ESPECIALISTA
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
